import React from "react";
import QuoteBox from "../quote-box";
import PropTypes from "prop-types";
import styles from "./styles.css";

// import img from "../images/rc-transfer.svg";

const StaticTestimonial = ({
    headingText,
    imageSrc,
    text,
    sellerName
}) => {
    return (
        <React.Fragment>
            <h2 className="text-center">{headingText}</h2>
            <div className="row">
                <div className="col-12 col-md-6" styleName={"styles.imageWrap"}>
                    <img src={imageSrc} className="img-fluid" alt={"testimonialImage"}/>
                </div>
                <div className="col-12 col-md-6">
                    <div className="py-4">
                        <QuoteBox >
                            {text}
                        </QuoteBox>
                    </div>
                    <h4>{sellerName}</h4>
                </div>
            </div>
        </React.Fragment>
    );

};
StaticTestimonial.propTypes = {
    headingText: PropTypes.string,
    imageSrc: PropTypes.string,
    text: PropTypes.string,
    sellerName: PropTypes.string
};

export default StaticTestimonial;
